export {default} from './Deliverable';


// WEBPACK FOOTER //
// ./src/components/Project/Deliverable/index.js